export default __webpack_public_path__ + "static/media/bg6.5f3fda54.jpg";